// Libraries
import { SlideOptions } from '@chakra-ui/react';
// Data
import { BreakpointsKeys } from '@globalTypes/index';
import { ReactElement } from 'react';

/**
 * The DialogerTypes enum represents the types of dialog components.
 */
export enum DialogerTypes {
  modal = 'modal',
  drawer = 'drawer',
}

/**
 * The DialogerTypesKeys type represents the keys of the DialogerTypes enum.
 */
export type DialogerTypesKeys = keyof typeof DialogerTypes;

/**
 * The DialogerTypesBreakPoints type maps breakpoints to dialog types.
 */
export type DialogerTypesBreakPoints = Partial<Record<BreakpointsKeys, DialogerTypesKeys>>;

/**
 * The DialogerSetup type represents the setup configuration for a dialog.
 */
export type DialogerSetup = {
  /**
   * The placement of the  dialoger.
   */
  placement?: SlideOptions['direction'];
  /**
   * The height of the dialoger when drawer.
   */
  isFullHeight?: boolean;
  /**
   * The header to display in the dialoger.
   */
  header: ReactElement;
  /**
   * The body to display in the dialoger.
   */
  body: ReactElement;
};
